import React, { useEffect } from "react";

const MAX_INDICATORS = 2;

const Indicators = ({
  rows,
  setRows,
  initialState,
  setting,
  setSetting,
  setIsSubmit,
  isSubmit,
  loader,
}) => {
  const createInitialState = () => ({
    selectValue: "",
    inputValue: "",
    selectPosValue: "above",
  });

  // Prevent indicators from reappearing on period change if all rows are '----None----' or indicators have been cleared
  useEffect(() => {
    if (setting.period) {
      const allNone = rows.every((row) => row.selectValue === "");
      if (allNone || setting.clearIndicator) {
        setRows([createInitialState()]);
        setSetting((prev) => ({
          ...prev,
          indicatorParams: [],
          clearIndicator: true,
        }));
      }
      // Do NOT reset indicators on period change if not cleared
    }
  }, [setting.period]);

  // REMOVE THIS EFFECT:
  // useEffect(() => {
  //   if (!setting.clearIndicator) {
  //     const nonEmptyRows = rows.filter((row) => row.selectValue !== "");
  //     setSetting({ ...setting, indicatorParams: nonEmptyRows });
  //   }
  // }, []);

  // const handleSubmit = () => {
  //   const cleanedRows = rows.filter((row) => row.selectValue !== "");

  //   if (cleanedRows.length === 0) {
  //     const newInitial = createInitialState();
  //     setRows([newInitial]);
  //     setTimeout(() => {
  //       setSetting({
  //         ...setting,
  //         indicatorParams: [],
  //         clearIndicator: true,
  //       });
  //     }, 0);
  //     return;
  //   }

  //   setRows(cleanedRows);
  //   setSetting({
  //     ...setting,
  //     indicatorParams: cleanedRows,
  //     clearIndicator: false,
  //   });
  //   setIsSubmit(!isSubmit);
  // };

  const handleSubmit = () => {
  const cleanedRows = rows.filter((row) => row.selectValue !== "");

  if (cleanedRows.length === 0) {
    // ✅ Reset properly
    setRows([createInitialState()]);
    setSetting({
      ...setting,
      indicatorParams: [],
      clearIndicator: true,
    });
    return; // stop here so nothing re-adds
  }

  // ✅ Always append an empty row at the end
  const finalRows =
    cleanedRows.length < 10 ? [...cleanedRows, createInitialState()] : cleanedRows;

  setRows(finalRows);
  setSetting({
    ...setting,
    indicatorParams: cleanedRows,
    clearIndicator: false,
  });
  setIsSubmit(!isSubmit);
};


  const handleSelectChange = (index, value) => {
    const wasEmpty = rows[index]?.selectValue === "";
    const currentActive = rows.filter((r) => r.selectValue !== "").length;
    if (wasEmpty && value !== "" && currentActive >= MAX_INDICATORS) {
      // Client, Indicator Polish 2: "Remove the limit error toast."
      //
      // The limit itself stays — the client confirmed "our allowed maximum of
      // two indicators is correct" — but it is now enforced by not OFFERING a
      // third row (see visibleRows below) rather than by letting the user pick
      // one and then scolding them. This guard is the belt-and-braces behind
      // that: unreachable through the UI, silent if it is ever reached.
      return;
    }
    const newRows = [...rows];
    newRows[index].selectValue = value;
    switch (value) {
      case "adl":
        newRows[index].inputValue = "0";
        newRows[index].selectPosValue = "below";
        break;
      case "adx":
        newRows[index].inputValue = "14";
        newRows[index].selectPosValue = "below";
        break;
      case "cci":
        newRows[index].inputValue = "20";
        newRows[index].selectPosValue = "below";
        break;
      case "cmf":
        newRows[index].inputValue = "20";
        newRows[index].selectPosValue = "below";
        break;
      case "macd":
        newRows[index].inputValue = "12,26,9";
        newRows[index].selectPosValue = "below";
        break;
      case "macdh":
        newRows[index].inputValue = "12,26,9";
        newRows[index].selectPosValue = "below";
        break;
      case "mfi":
        newRows[index].inputValue = "14";
        newRows[index].selectPosValue = "below";
        break;
      case "obv":
        newRows[index].inputValue = "0";
        newRows[index].selectPosValue = "below";
        break;
      case "ppo":
        newRows[index].inputValue = "12,26,9";
        newRows[index].selectPosValue = "below";
        break;
      case "pvo":
        newRows[index].inputValue = "12,26,9";
        newRows[index].selectPosValue = "below";
        break;
      case "roc":
        newRows[index].inputValue = "12";
        newRows[index].selectPosValue = "below";
        break;
      case "efi":
        newRows[index].inputValue = "13";
        newRows[index].selectPosValue = "below";
        break;
      case "mh":
        newRows[index].inputValue = "12,26,9";
        newRows[index].selectPosValue = "below";
        break;
      case "price":
        newRows[index].inputValue = "$SPX";
        newRows[index].selectPosValue = "below";
        break;
      case "rsi":
        newRows[index].inputValue = "14";
        newRows[index].selectPosValue = "below";
        break;
      case "stoch":
        newRows[index].inputValue = "14,3,3";
        newRows[index].selectPosValue = "below";
        break;
      default:
        newRows[index].inputValue = "";
    }

    if (newRows.length < 10 && index === newRows.length - 1) {
      newRows.push(createInitialState());
    }
    handleInputChange(index, newRows[index].inputValue);
    setRows(newRows);

    // Update indicatorParams and clearIndicator when selection changes
    const nonEmptyRows = newRows.filter((row) => row.selectValue !== "");
    setSetting({
      ...setting,
      indicatorParams: nonEmptyRows,
      clearIndicator: false,
    });
  };

  const handleInputChange = (index, value) => {
    const newRows = [...rows];
    newRows[index].inputValue = value ? value : "";
    if (newRows[index].selectValue === "adl") {
      setSetting({
        ...setting,
        adlValue: value,
      });
    }
    if (newRows[index].selectValue === "adx") {
      setSetting({
        ...setting,
        adxValue: value,
      });
    }
    if (newRows[index].selectValue === "cci") {
      setSetting({
        ...setting,
        cciValue: value,
      });
    }
    if (newRows[index].selectValue === "cmf") {
      setSetting({
        ...setting,
        cmfValue: value,
      });
    }
    if (newRows[index].selectValue === "macd") {
      setSetting({
        ...setting,
        macdValue: value,
      });
    }
    if (newRows[index].selectValue === "mfi") {
      setSetting({
        ...setting,
        mfiValue: value,
      });
    }
    if (newRows[index].selectValue === "obv") {
      // setSetting({
      //   ...setting, obvValue: value
      // })
    }
    if (newRows[index].selectValue === "ppo") {
      setSetting({
        ...setting,
        ppoValue: value,
      });
    }
    if (newRows[index].selectValue === "pvo") {
      setSetting({
        ...setting,
        pvoValue: value,
      });
    }
    if (newRows[index].selectValue === "roc") {
      setSetting({
        ...setting,
        rocValue: value,
      });
    }
    if (newRows[index].selectValue === "efi") {
      setSetting({
        ...setting,
        efiValue: value,
      });
    }
    if (newRows[index].selectValue === "macdh") {
      setSetting({
        ...setting,
        macdhValue: value,
      });
    }
    if (newRows[index].selectValue === "rsi") {
      setSetting({
        ...setting,
        rsiValue: value,
      });
    }
    if (newRows[index].selectValue === "stoch") {
      setSetting({
        ...setting,
        stochValue: value,
      });
    }
    setRows(newRows);
  };

  const handleClearAll = () => {
    setRows([initialState]);
    setSetting({
      ...setting,
      indicatorParams: [],
      clearIndicator: true,
    });
  };

  const handlePositionChange = (index, value) => {
    const newRows = [...rows];
    newRows[index].selectPosValue = value;
    setRows(newRows);
  };

  const isMobileView = document.body.clientWidth <= 768;
  const options = [
    // Client, Indicator Polish 2: "Replace `----None----` with `Select
    // indicator`." It is the empty row's prompt, so it should read as an
    // instruction, not as a value called "None".
    { value: "", label: "Select indicator" },
    { value: "adl", label: "Accumulation/Distribution Line (ADL)" },
    { value: "adx", label: "ADX Line (w/+DI and -DI)" },
    { value: "cci", label: "Commodity Channel Index (CCI)" },
    { value: "cmf", label: "Chaikin Money Flow (CMF)" },
    { value: "macd", label: "MACD" },
    { value: "macdh", label: "MACD Histogram" },
    { value: "mfi", label: "Money Flow Index (MFI)" },
    { value: "obv", label: "On Balance Volume (OBV)" },
    { value: "ppo", label: "Pct Price Oscillator (PPO)" },
    { value: "pvo", label: "Pct Volume Oscillator (PVO)" },
    { value: "roc", label: "Rate of Change (ROC)" },
    { value: "efi", label: "Force Index (EFI)" },
    { value: "stoch", label: "Full Stochastics (STOCH)" },
    { value: "rsi", label: "Relative Strength Index (RSI)" },
    // { value: "fs", label: "Full Stochastics" },
  ];

  // Client, Indicator Polish 2: "once two are selected, do not display a third
  // selection row. If one is removed, the empty row should return."
  //
  // `rows` state is left exactly as it was — it still carries the trailing empty
  // row that handleSelectChange appends — and only the RENDER is trimmed. That
  // is what makes the row come back by itself: clear one indicator back to
  // "Select indicator", the active count drops to 1, and the row that was always
  // in state simply becomes visible again. No add/remove bookkeeping, nothing to
  // get out of step.
  // Show every chosen indicator, plus EXACTLY ONE empty row while there is room
  // for another — "If one is removed, the empty row should return", singular.
  // rows state can hold more than one trailing empty (handleSelectChange appends
  // one whenever the last row is filled, and clearing a middle row leaves its own
  // blank behind), so the render collapses them rather than showing a stack of
  // identical "Select indicator" dropdowns.
  const chosenRows = rows.filter((r) => r.selectValue !== "");
  const visibleRows =
    chosenRows.length >= MAX_INDICATORS
      ? chosenRows
      : [...chosenRows, rows.find((r) => r.selectValue === "") || createInitialState()];

  return (
    <div className="text-gray-900 rounded col-span-4">
      <div className="">
        <div className="space-y-1">
          {/* The "Add up to 2 indicators." helper line moved OUT of here and into
              the modal header as a subtitle — client, 2: it belongs under the
              title, above the header rule, not in the body below it. Desktop
              passes it via SimpleModal's `subtitle`; the mobile sheet renders it
              under its own <h3>. */}
          <div className="flex flex-row">
            <table className="table-auto" style={{ width: "100%" }}>
              <thead>
                <tr>
                 {/* Client, Indicator Polish 2: "(remove the plural from
                     Indicators)" — the column heads each name ONE row's field,
                     so this reads "Indicator | Parameters | Position". */}
                  <td className="font-bold" id="chart-indicators-guide">Indicator</td>
                  <td className="font-bold" style={{ width: "100px" }}>
                    Parameters
                  </td>
                  <td className="font-bold" style={{ width: "70px" }}>
                    Position
                  </td>
                </tr>
              </thead>
              <tbody>
                {visibleRows.map((row, index) => (
                  <tr key={`indicator-${index}`}>
                    <td>
                      <select
                        id="colorMode"
                        value={row.selectValue}
                        onChange={(e) =>
                          handleSelectChange(index, e.target.value)
                        }
                        className={
                          isMobileView
                            ? "text-[12px] appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            : "text-[12px] appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        }
                      >
                        {/* PLACEHOLDER, NOT A CHOICE.
                            Client: "Select indicator appears as one of the
                            selectable options in the middle of the list. Please
                            remove it from the dropdown options. Keep it only as the placeholder text in the
                            input field… there is no reason to have Select
                            Overlay or Indicator in the list on desktop and
                            mobile, a user can click outside the options and has
                            clear all."

                            It sorted into the MIDDLE because it was a real
                            option carrying a real label. `hidden` takes it out
                            of the open list while the closed field still shows
                            it whenever nothing is chosen; `disabled` is the
                            fallback for a browser that ignores `hidden`, and
                            rendering it before the sorted list means that
                            fallback puts it at the top rather than mid-list.

                            The entry STAYS in the options array — the empty
                            value is still what a cleared row holds, and lookups
                            by value resolve against it. */}
                        <option value="" disabled hidden>
                          Select indicator
                        </option>
                        {options
                          .filter((option) => option.value !== "")
                          .sort((a, b) => a.label.localeCompare(b.label))
                          .map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                      </select>
                    </td>
                    <td>
                      <input
                        type="text"
                        value={row.inputValue}
                        onChange={(e) =>
                          handleInputChange(index, e.target.value)
                        }
                        placeholder="Enter parameters"
                        className={
                          isMobileView
                            ? "text-[12px] appearance-none border rounded w-32 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            : " text-[12px] appearance-none border rounded w-32  py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        }
                      />
                    </td>
                    <td>
                      <select
                        id="positionMode"
                        value={row.selectPosValue}
                        onChange={(e) =>
                          handlePositionChange(index, e.target.value)
                        }
                        className={
                          isMobileView
                            ? "text-[12px] appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            : "text-[12px] appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        }
                      >
                        <option value="above">Above</option>
                        {/* <option value="price">Behind Price</option>
                        <option value="ind">Behind Ind</option> */}
                        <option value="below">Below</option>
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="flex flex-row">
            <button
              disabled={!setting.period || !setting.symbol}
              onClick={handleSubmit}
              className="bg-primaryColor text-white rounded p-2 mt-2 mr-2 w-full"
              id={"indicatorUpdate"}
            >
              {loader ? "please wait .." : "Update"}
            </button>
            {/* Client, Indicator Polish 3: "Keep `Update` as the primary button
                and change `Clear All` to an outlined secondary button. The
                outline and 'Clear All' text should be in dark teal; the button
                is white."

                Dark teal is the existing primaryColor token (#004C50) — the
                same ink Update is filled with — so the pair reads as one
                primary/secondary set rather than two competing buttons. */}
            <button
              onClick={handleClearAll}
              className="bg-white text-primaryColor border border-primaryColor rounded p-2 mt-2 ml-2 w-full hover:bg-primaryColor/5"
            >
              {"Clear All"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Indicators;